module.exports = __webpack_public_path__ + "static/media/icon_interactive.59a5d501.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/navigation/icon_interactive.svg
// module id = 407
// module chunks = 0